module.exports = __webpack_public_path__ + "75b57bdb794391588538a445975d606b.svg";